import { z } from "zod";
import { UI_DECISIONS } from "@/features/compensation/schemas/comp-plan.schema";

/// URL search-params schema for `/$slug/compensation`. `scope` is the single
/// tab dimension (frontend-ia section 3 scope law):
///
///   mine      , my letters, band, history (everyone; CMP-054 fills it)
///   planning  , worksheets assigned to me (planners; CMP-037 fills it)
///   workspace , cycles table + setup (admins via COMP_CYCLE_VIEW_WORKSPACE)
///
/// Tab visibility is enforced in the tab strip (hide what the caller cannot
/// use) AND in the route (refuse-by-redirect to `mine`), so a bookmarked URL
/// cannot bypass the gate (Q11).
export const COMPENSATION_SCOPES = ["mine", "planning", "workspace"] as const;
export type CompensationScope = (typeof COMPENSATION_SCOPES)[number];

export const compensationRouteSearchSchema = z
  .object({
    scope: z.enum(COMPENSATION_SCOPES).catch("workspace").default("workspace"),
    /// Workspace lens only: include archived cycles in the table.
    archived: z.boolean().optional(),
    q: z.string().optional(),
    worksheet: z.string().optional(),
    worksheetQ: z.string().optional(),
    worksheetDepartment: z.string().optional(),
    worksheetDecision: z.enum(UI_DECISIONS).optional(),
    /// Workspace lens only: which workspace panel is open (w5-gate verdict 3).
    tab: z.enum(["cycles", "setup"]).optional(),
  })
  .strict();
export type CompensationRouteSearch = z.infer<typeof compensationRouteSearchSchema>;
